import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { _Api } from "../../../common/api";

export default function CollectionBlock() {
  const [collectionData, setCollectionData] = useState([]);
  const collectionRefs = useRef([]);
  const { t } = useTranslation();

  const fetchBottomBarData = async () => {
    try {
      const postdata = {
        slug: ["block-info-3", "block-info-4"]
      };
      const res = await _Api(postdata, `Cms/get-ecom-blocks`);
      if (res?.status === 200) {
        setCollectionData(res?.data);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchBottomBarData();
  }, []);

  useEffect(() => {
    if (collectionData.length) {

      collectionData.forEach((data, index) => {
        const element = collectionRefs.current[index];
        if (element instanceof HTMLElement) {
          element.innerHTML = data.content;
        }
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate-in");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );

      collectionRefs.current.forEach((block) => {
        if (block instanceof HTMLElement) observer.observe(block);
      });

      return () => {
        collectionRefs.current.forEach((block) => {
          if (block instanceof HTMLElement) observer.unobserve(block);
        });
      };
    }
  }, [collectionData]);

  return (
    <div className="collectionblock">
      <div className="collectionblock-inner">
        {collectionData.length ? (
          collectionData.map((_, key) => (
            <div
              key={key}
              ref={(el) => (collectionRefs.current[key] = el)}
              className={`collectionblock-inner-block ${
                key % 2 === 0 ? "left" : "right"
              }`}
            ></div>
          ))
        ) : (
          null
        )}
      </div>
    </div>
  );
}
